<template>
  <div>
    <a-modal
      :title="modalTit"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :width="780"
      :centered="true"
      wrap-class-name="export-modal"
      :destroy-on-close="true"
      :footer="null"
      :mask-closable="false"
      :ok-text="okTTxt"
      :cancel-text="cancelTxt"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p class="prompt">
        {{ $t('message[1774]') }}
      </p>
      <div class="content clearfix">
        <div class="left fl">
          <h3>{{ $t('message["1414"]') }}</h3>
          <div
            v-if="treeData"
            class="result scroll_bar_beautify_ff"
          >
            <a-tree
              v-if="treeData[0] && treeData[0].fieldkey"
              checkable
              show-icon
              :default-expanded-keys="[treeData[0].fieldkey]"
              :tree-data="treeData"
              :checked-keys="checkedKeys"
              @check="onCheck"
            />
          </div>
        </div>
        <span class="border" />
        <div class="right fl">
          <h3>{{ $t('message["1480"]') }}</h3>
          <draggable
            v-model="myList"
            :options="{
              animation: 60,
              handle:'.dray-item'
            }"
            class="result scroll_bar_beautify_ff"
            @end="dragEndHandle"
          >
            <transition-group>
              <div
                v-for="(item, i) in myList"
                :key="i"
                class="item clearfix"
                :class="{ 'active': item.active}"
              >
                <div class="dray-item fl">
                  <i class="iconfont iconicon-test72 move-icon" />
                  <span>{{ item.fieldname }}</span>
                </div>
                <i
                  class="iconfont iconicon-test5 fr close-icon"
                  @click="onDelete(item, i)"
                />
              </div>
            </transition-group>
          </draggable>
        </div>
      </div>
      <div class="footer">
        <a-button
          class="ml-16"
          @click="handleCancel"
        >
          {{ $t('message["896"]') }}
        </a-button>
        <a-button
          :disabled="!myList.length"
          type="primary"
          @click="handleOk"
        >
          {{ $t('message["915"]') }}
        </a-button>
      </div>
    </a-modal>
    <a-modal
      :visible="progerssVisible"
      :footer="null"
      :width="304"
      :closable="false"
      :destroy-on-close="true"
      :mask-closable="false"
      class="progerss-modal"
    >
      <div
        class="progress-modal-box"
      >
        <h2 class="progress-tit">
          {{ $t('message["1782"]') }}
        </h2>
        <a-progress
          :percent="percent"
        />
        <div
          class="cancel-progress-btn"
        >
          <a-button @click="cancelErport">
            {{ $t('message["896"]') }}
          </a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'
// import { exportExcel } from '@/lib/utils'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import moment from 'moment'
import { setCodeData, base64ToJson } from '@/lib/utils'
import { getEncode } from '@/lib/mix'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    from: {
      type: String,
      default: ''
    },
    type: {
      type: [String, Number],
      default: ''
    },
    paramsType: {
      type: [String, Number],
      default: ''
    },
    fieldkey: {
      type: String,
      default: ''
    },
    fieldvalue: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isVisible: false,
      confirmLoading: false,
      checkedKeys: [],
      resultKeys: [],
      exportAllData: {
        count: 0,
        title: [],
        list: []
      },
      progerssVisible: false,
      percent: 0,
      isExportCancel: false
    }
  },
  computed: {
    ...mapState('inquery/listData', ['tableSort']),
    ...mapState('inquery/exportData', ['exportFormData', 'exportResult', 'exportExcelData']),
    ...mapState('inquery/filterData', ['filterResult', 'filterStr']),
    myList: {
      get () {
        return _.reduce(this.exportResult, (res, item) => {
          res.push(item)
          return res
        }, [])
      },
      set (value) {
        this.$store.commit('UPDATE_RESULT', value)
      }
    },
    treeData () {
      let obj = {}
      obj.child = this.exportFormData
      this.setTreeData(obj)
      return obj.children
    },
    /* codeStr () {
      const { query = {} } = this.$route
      return query.code || ''
    }, */
    /* filterStr () {
      const { query = {} } = this.$route
      return query.filter
    }, */
    filters () {
      let filters = {}
      if (this.filterStr) {
        filters = base64ToJson(this.filterStr)
      }

      return filters
    },
    currentPage () {
      const { page = 1 } = this.$route.query
      return parseInt(page)
    },
    pageSize () {
      const { limit = 10 } = this.$route.query
      return parseInt(limit)
    },
    viewid () {
      return this.$route.query.viewid
    },
    issystem () {
      return this.$route.query.issystem
    },
    modalTit () {
      return this.$t('message["188"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    }
  },
  watch: {
    async visible (val) {
      this.isVisible = val
      if (val) {
        await this.getExportData()
      }
    },
    treeData (val) {
      this.checkedKeys = []
      this.getCheckedKeys(val)
    },
    progerssVisible (val) {
      if (!val) {
        this.isExportCancel = true
        this.percent = 0
      } else {
        this.isExportCancel = false
      }
    }
  },
  methods: {
    ...mapActions('inquery/exportData', ['fetchExportConfig', 'setExportConfig', 'fetchExportExcelData']),
    /**
     * 获取覆层上初始数据
     */
    async getExportData () {
      const chain = await this.fetchExportConfig()
      chain
        .params({
          scope: this.from,
          type: this.paramsType
        })
        .fetch()
    },

    /**
     * 处理左侧树的数据结构，为组件可用的key和value
     */
    setTreeData (obj) {
      obj.children = []
      for (let k in obj.child) {
        let item = obj.child[k]
        item.title = item.fieldname
        item.key = item.fieldkey
        // item.slots = { icon: 'treeNodeIcon' }
        obj.children.push(item)
        if (item.child) {
          this.setTreeData(item)
        }
      }
    },

    /**
     * 通过左侧树 选中状态，获取所有checkedKeys
     */
    getCheckedKeys (children) {
      if (!children || !children.length) return
      for (let item of children) {
        if (item.ischecked) {
          if (!this.checkedKeys.includes(item.fieldkey)) {
            this.checkedKeys.push(item.fieldkey)
          }
        }
        if (item.children) {
          let checkArray = []
          item.children.map(items => {
            if (items.ischecked) {
              checkArray.push(items)
            }
          })
          if (checkArray.length === item.children.length) {
            item.ischecked = 1
            this.checkedKeys.push(item.fieldkey)
          }
          this.getCheckedKeys(item.children)
        }
      }
    },

    /**
     * 设置左侧树选中状态
     */
    setChecked (children, type) {
      if (!children || !children.length) return
      for (let item of children) {
        this.$set(item, 'ischecked', type)
        if (item.children) {
          this.setChecked(item.children, type)
        }
      }
    },

    /**
     * 点击左侧树复选框的事件
     */
    onCheck (checkedKeys = [], info = {}) {
      this.checkedKeys = checkedKeys
      const { node = {} } = info
      const { dataRef = {} } = node
      const { fieldkey = '' } = dataRef
      this.setTreeDataChecked(dataRef, fieldkey)
    },

    /**
     * 左侧树 选中/取消 的值，同步到 右侧结果列表
     */
    setTreeDataChecked (currentNode, currKey) {
      if (!currentNode.children || !currentNode.children.length) { // 点的子级
        if (this.checkedKeys.includes(currKey) && !this.myList.includes(currKey)) { // 点中
          this.$set(currentNode, 'ischecked', 1)
          this.myList.push(currentNode)
        } else { // 取消选中
          this.$set(currentNode, 'ischecked', 0)
          for (let index in this.myList) {
            if (this.myList[index].fieldkey === currentNode.fieldkey) {
              this.myList.splice(index, 1)
            }
          }
        }
      } else { // 点的父级
        let arr = []
        this.mergeChildren(arr, currentNode.children)
        if (this.checkedKeys.includes(currKey)) { // 点中
          this.setChecked(currentNode.children, 1)
          for (let item of arr) {
            if (!this.myList.map(items => items.fieldkey).includes(item.fieldkey)) {
              this.myList.push(item)
            }
          }
        } else { // 取消选中
          this.setChecked(currentNode.children, 0)
          for (let i = this.myList.length - 1; i >= 0; i--) {
            const one = this.myList[i] || {}
            for (let item of arr) {
              if (item.fieldkey === one.fieldkey) {
                this.myList.splice(i, 1)
              }
            }
          }
        }
      }
    },

    /**
     * 左侧树 选中 父级时，合并所有子元素到一个数组
     */
    mergeChildren (arr, children) {
      if (children && children.length) {
        for (let item of children) {
          if (!item.children) {
            arr.push(item)
          } else {
            this.mergeChildren(arr, item.children)
          }
        }
      }
    },

    /**
     * 右侧数据拖拽
     */
    dragEndHandle ({ oldIndex, newIndex }) {
      const item = this.myList[oldIndex]
      this.myList.splice(oldIndex, 1)
      this.myList.splice(newIndex, 0, item)
      this.checkedKeys = this.myList.map(item => item.fieldkey)
      this.$forceUpdate()
    },
    /**
     * 右侧数据删除
     */
    onDelete (item, index) {
      this.myList.splice(index, 1)
      this.checkedKeys = this.myList.map(item => item.fieldkey)
      this.$forceUpdate()
    },

    /**
     * 隐藏覆层
     */
    hide () {
      this.$emit('update:visible', false)
    },

    /**
     * 点击覆层上的取消按钮
     */
    handleCancel () {
      this.hide()
    },

    /**
     * 点击覆层上的确定按钮（保存导出配置的设置结果，然后导出数据到excel）
     */
    async handleOk () {
      this.exportAllData.list = []
      await this.setExport()
      this.hide()
    },

    /**
     * 保存导出配置的设置结果
     */
    async setExport () {
      this.resultKeys = this.myList.map(item => item.fieldkey)
      const chain = await this.setExportConfig()

      chain
        .onSuccess(async (res) => {
          let page = 1
          let limit = 200
          this.percent = 0
          this.progerssVisible = true
          this.requestExportList(page, limit)
        })
        .params({
          scope: this.from,
          type: this.type,
          config: this.resultKeys
        })
        .fetch()
      this.myList = []
    },

    // 点击筛选的确定按钮时，处理数据为 key: value 格式
    async setFilterRequestParams (filter) {
      let obj = {}
      const enCode = await getEncode()
      for (let fieldkey in filter) {
        const item = filter[fieldkey]
        switch (item.fieldtype) {
          case 'text':
          case 'phone':
          case 'email':
          case 'editor':
          case 'tag':
            obj[fieldkey] = await setCodeData(item.fieldvalue, enCode)
            break
          case 'area':
            obj[fieldkey] = item.fieldvalue && Object.keys(item.fieldvalue)
            break
          case 'select_tree':
            obj[fieldkey] = item.fieldvalue && Object.keys(item.fieldvalue)
            break
          case 'from_info':
            let { fieldvalue = [] } = item

            let arr = []
            for (let i in fieldvalue) {
              let fields = fieldvalue[i] || []

              let one = {}
              let len = fields.length

              if (len === 1) {
                one['from_info.from'] = fields[0].fieldkey
              } else if (len === 2) {
                let fieldItem = fields[1] || {}
                one[fieldItem.fieldkey] = fields[1].inputVal
              } else if (len === 3) {
                let fieldItem = fields[1] || {}
                one[fieldItem.fieldkey] = fields[2].id
              }
              if (Object.keys(one).length) {
                arr.push(one)
              }
            }

            obj[fieldkey] = arr
            break
          case 'radioinfo_type':
            obj['base_info.info_sign'] = item.info_sign
            obj[fieldkey] = item.fieldvalue
            break
          default:
            obj[fieldkey] = item.fieldvalue
            break
        }
      }
      return obj
    },
    /**
     * 请求导出的数据
     */
    async requestExportList (page, limit) {
      let params = {}
      if (this.filterStr) {
        let filterData = await this.setFilterRequestParams(this.filters)
        params.search = filterData
      }

      if (this.fieldvalue) {
        const enCode = await getEncode()
        params.fieldkey = this.fieldkey
        params.fieldvalue = await setCodeData(this.fieldvalue, enCode)
      }
      if (this.viewid) {
        params.viewid = this.viewid
        params.issystem = this.issystem
      }

      const chain = await this.fetchExportExcelData()
      chain
        .params({
          ...params,
          scope: this.from,
          type: this.paramsType,
          page,
          limit,
          ...this.tableSort
        })
        .onSuccess((res) => {
          const { title = {}, data = {} } = res
          const { count = 0 } = data
          this.exportAllData.title = title
          this.exportAllData.count = parseInt(count)
          this.exportAllData.list.push(...data.list)
          const pageCount = Math.ceil(this.exportAllData.count / limit)
          this.percent = Math.floor(page * 100 / pageCount)
          if (!this.isExportCancel) {
            if (page * limit < this.exportAllData.count) {
              page++
              this.requestExportList(page, limit)
            } else {
              this.percent = 100
              // if (this.exportAllData.count > 200) {
              //   this.progerssVisible = false
              //   this.getExportList()
              // } else {
              //   setTimeout(() => {
              //     this.progerssVisible = false
              //     this.getExportList()
              //   }, 200)
              // }
              setTimeout(() => {
                this.progerssVisible = false
                this.getExportList()
              }, 200)
            }
          }
        })
        .fetch()
    },

    /**
     * 导出 excel 表格的数据列表
     */
    async getExportList () {
      // 处理fieldvalue
      const list = _.reduce(this.exportAllData.list, (res, item) => {
        for (let fieldkey in item) {
          let column = item[fieldkey]
          if (this.$toType(column) === 'object' && column.hasOwnProperty('fieldvalue')) {
            item[fieldkey] = column.fieldvalue
          }
        }
        res.push(item)
        return res
      }, [])

      // titles 和 list
      let excelData = this.jsonToExcelData(this.exportAllData.title, list)
      this.exportExcel(excelData)
      // exportExcel(titles, list) // 用html表格生成
    },
    jsonToExcelData (title, list) {
      let titleArray = []
      let dataArray = []
      title.map(values => {
        titleArray.push(values.fieldname)
        list.map((item, indexs) => {
          let value = item[values.fieldkey]
          if (value) {
            if (this.$toType(value) === 'array') {
              if (values.fieldkey === 'comments' || values.fieldkey === 'followups') {
                value = value.map(items => {
                  let time = items.addtime ? moment(items.addtime * 1000).format('MM-DD') : ''
                  console.log(items.addtime, time)
                  return time + ' ' + items.content
                }).join('; ')
              } else {
                value = value.join('; ')
              }
            }
          }
          if (dataArray[indexs]) {
            dataArray[indexs].push(value)
          } else {
            dataArray[indexs] = [value]
          }
        })
      })
      dataArray.unshift(titleArray)
      return dataArray
    },
    make_cols (refstr) {
      var o = []
      var range = XLSX.utils.decode_range(refstr)
      for (var i = 0; i <= range.e.c; ++i) {
        o.push({ name: XLSX.utils.encode_col(i), key: i })
      }
      return o
    },
    exportExcel (excelData) {
      const defaultCellStyle = {
        font: {
          name: 'Verdana',
          sz: 11,
          color: 'FF00FF88'
        },
        fill: {
          fgColor: {
            rgb: 'FFFFAA00'
          }
        }
      }
      const wopts = {
        bookType: 'xlsx',
        bookSST: false,
        type: 'binary',
        defaultCellStyle: defaultCellStyle,
        showGridLines: false
      }
      const wb = {
        SheetNames: ['Sheet1'],
        Sheets: {},
        Props: {}
      }
      // this.make_cols('!autofilter')
      // wb.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(excelData)
      wb.Sheets['Sheet1'] = XLSX.utils.aoa_to_sheet(excelData)

      // 创建二进制对象写入转换好的字节流
      let tmpDown = new Blob([this.s2ab(XLSX.write(wb, wopts))], { type: 'application/octet-stream' })
      let title = moment(new Date().getTime()).format('YYYY-MM-DD HH:mm:ss')
      FileSaver.saveAs(tmpDown, `${title}.xlsx`)
    },
    // 字符串转字符流
    s2ab (s) {
      if (typeof ArrayBuffer !== 'undefined') {
        let buf = new ArrayBuffer(s.length)
        var view = new Uint8Array(buf)
        for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
        return buf
      } else {
        let buf = new Array(s.length)
        for (let i = 0; i !== s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF
        return buf
      }
    },
    // 取消导出
    cancelErport () {
      this.isExportCancel = true
      this.progerssVisible = false
    }
  }
}
</script>

<style lang="scss">
.export-modal {
  .ant-modal {
    /* top: 50%;
    margin-top: -346px; */
    padding-bottom: 0;
  }
  .ant-modal-body {
    padding: 0 40px 16px;
  }
  .ant-tree li span.ant-tree-switcher {
    color: #ccc;
  }
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_open
    .ant-tree-switcher-icon,
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_open
    .ant-select-switcher-icon,
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_close
    .ant-tree-switcher-icon,
  .ant-tree
    li
    span.ant-tree-switcher.ant-tree-switcher_close
    .ant-select-switcher-icon {
    font-size: 24px;
    color: #999;
  }
  .ant-tree > li {
    > .ant-tree-node-content-wrapper {
      .ant-tree-title {
        font-weight: bold;
      }
    }
  }
}
.progerss-modal::v-deep{
  .ant-modal-body{
    padding: 32px;
  }
}
</style>
<style lang="scss" scoped>
.prompt {
  min-height:40px;
  line-height: 40px;
  margin: 0 -40px 12px;
  padding: 0 24px;
  color: #4CA0F2;
  background:#E8F4FF;
}
.content {
  position: relative;
  padding-bottom: 12px;
  // height: 524px;
  // overflow-y: auto;
  h3 {
    height: 48px;
    line-height: 48px;
    font-weight: bold;
  }
  .left {
    width: 320px;
    margin-right: 40px;
    .result {
      max-height: 524px;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
  .border {
    position: absolute;
    left: 320px;
    top: 0;
    width: 0;
    height: 100%;
    border-right: solid 1px $gray4;
  }
  .right {
    width: 320px;
    .result {
      max-height: 524px;
      overflow-x: hidden;
      overflow-y: auto;
    }
    .item {
      overflow: hidden;
      height: 32px;
      line-height: 32px;
      padding: 0 12px;
      &:hover {
        background-color: #f4f7f9;
        .iconfont.move-icon {
          opacity: 1;
        }
      }
    }
    .dray-item {
      cursor: move;
    }
    .iconfont.move-icon {
      opacity: 0;
      margin-right: 4px;
      color: #ccc;
    }
    .iconfont.close-icon {
      margin-right: 20px;
      cursor: pointer;
      color: #d6d6d6;
    }
  }
}
.footer {
  text-align: right;
}
.progress-modal-box {
  .progress-tit {
    line-height: 24px;
    margin-bottom: 6px;
  }
  .cancel-progress-btn {
    margin: 20px 0 0 0;
    text-align: right;
    .ant-btn {
      margin-right: 0;
    }
  }
}
</style>
